import { useLanguage, t } from "../../../i18n";
import React from "react";
import BaytBuddyLogo from "../../../assets/images/bb-logo-icon-trans.png";
import "./Logo.css";
export default function Logo() {
  useLanguage();
  return <div className="bb-sidebar__logo">
            <div className="bb-main-logo">
                <img src={BaytBuddyLogo} alt={t("BaytBuddy")} width="60" height="60" />

            </div>
            <div className="bb-logo-text">
                <div className="bb-logo-text-1">
                    <span>{t("Bayt")}</span>
                </div>
                <div className="bb-logo-text-2">
                    <span>{t("Buddy")}</span>
                </div>
            </div>
        </div>;
}
